import React from 'react';
import './hero-text.css'


const Herotext = (props) => {
    return ( 
        <article className='container-text-heroo'>
            <h1 className='header-hero'>{props.title}</h1>
            <p className='para-hero'>{props.para}</p>
        </article>
     );
}
 
export default Herotext;